// 供需与发布：英文字段。只维护显示文案，不改业务标识、数值或提交内容。

// 移动线索
export const mobileClue = Object.freeze({
  "mobileClue.searchPlaceholder": "Enter a search keyword",
  "mobileClue.noData": "No data available",
  "mobileClue.supplyPublished": "Supply listing published!",
  "mobileClue.demandPublished": "Purchase request published!",
  "mobileClue.supplyReviewHint":
    "A negotiator can be assigned after the supply listing is approved",
  "mobileClue.demandReviewHint":
    "A negotiator can be assigned after the purchase request is approved",
  "mobileClue.backHome": "Back to home",
  "mobileClue.searchPartOrName": "Search part numbers or names",
  "mobileClue.search": "Search",
  "mobileClue.listEnd": "You have reached the end",
  "mobileClue.supply": "Supply",
  "mobileClue.wantToBuy": "Want to buy",
});

// 批量发布
export const batchPublish = Object.freeze({
  "pcBatch.title": "Bulk import",
  "pcBatch.supply": "Publish supply in bulk",
  "pcBatch.demand": "Publish demand in bulk",
  "pcBatch.uploadTab": "Upload file",
  "pcBatch.drag": "Drag a file here, or",
  "pcBatch.clickUpload": "click to upload",
  "pcBatch.limit": "Supports xls/xlsx, up to 200 records per import",
  "pcBatch.remove": "Remove",
  "pcBatch.import": "Import",
  "pcBatch.downloadTemplate": "Download template",
  "pcBatch.templateHint":
    "Use the standard template to reduce conversion errors during automatic processing.",
  "pcBatch.maximumBefore": "Maximum records per import:",
  "pcBatch.maximumAfter": ".",
  "pcBatch.result": "Import result",
  "pcBatch.clear": "Clear",
  "pcBatch.successCount": "Succeeded: {count}; ",
  "pcBatch.failureCount": "failed: {count}",
  "pcBatch.excelOnly": "Only Excel files (.xls/.xlsx) are supported.",
  "pcBatch.chooseFile": "Choose an Excel file first.",
  "pcBatch.importSuccess": "Import successful",
  "pcBatch.importFailed": "Import failed. Please retry",
  "pcBatch.networkOrFileError":
    "Import failed. Check your connection or file contents",
});

// 桌面线索
export const desktopClue = Object.freeze({
  "pcClue.searchPlaceholder": "Search part numbers or names",
  "pcClue.productType": "Type:",
  "pcClue.productBrand": "Brand:",
  "pcClue.goodsLocationLabel": "Location:",
  "pcClue.goodsCondition": "Condition:",
  "pcClue.all": "All",
  "pcClue.expand": "Expand",
  "pcClue.collapse": "Collapse",
  "pcClue.publish": "Post a listing",
  "pcClue.manage": "Manage",
  "pcClue.supply": "Supply",
  "pcClue.demand": "Demand",
  "pcClue.buy": "Wanted",
  "pcClue.wide": "Wide",
  "pcClue.narrow": "Compact",
  "pcClue.card": "Cards",
  "pcClue.list": "List",
  "pcClue.endOfList": "You've reached the end",
  "pcClue.loadFailed": "Couldn't load data. Please try again.",
  "pcClue.type": "Type",
  "pcClue.partNumber": "Part number",
  "pcClue.brand": "Brand",
  "pcClue.category": "Category",
  "pcClue.location": "Location",
  "pcClue.currency": "Currency",
  "pcClue.usd": "USD",
  "pcClue.cny": "CNY",
  "pcClue.price": "Price",
  "pcClue.quantity": "Quantity",
  "pcClue.batch": "Batch",
  "pcClue.condition": "Condition",
  "pcClue.originalManufacturer": "Original manufacturer",
  "pcClue.deliveryTime": "Delivery time",
  "pcClue.days": "{count} days",
  "pcClue.undetermined": "Undetermined",
  "pcClue.publishedAt": "Posted",
  "pcClue.publisher": "Posted by",
  "pcClue.brandNew": "Brand new",
  "pcClue.stock": "Stock",
  "pcClue.demandQuantity": "Required quantity",
  "pcClue.minimumOrder": "Minimum order",
  "pcClue.deposit": "Deposit",
  "pcClue.region": "Region",
  "pcClue.bidDeadline": "Bid deadline",
  "pcClue.bidOpening": "Bid opening",
  "pcClue.fiveSuppliers": "5 suppliers",
  "pcClue.selectedCount": "{count} selected",
  "pcClue.delete": "Delete",
  "pcClue.review": "Review",
  "pcClue.monthDay": "{month}/{day}",
  "pcClue.brand.skHynix": "SK hynix",
  "pcClue.brand.samsung": "Samsung",
  "pcClue.brand.micron": "Micron",
  "pcClue.brand.infineon": "Infineon",
  "pcClue.brand.nxp": "NXP",
  "pcClue.brand.st": "STMicroelectronics",
  "pcClue.brand.ti": "Texas Instruments",
  "pcClue.brand.espressif": "Espressif",
  "pcClue.brand.gigaDevice": "GigaDevice",
  "pcClue.brand.winbond": "Winbond",
  "pcClue.brand.nanya": "Nanya",
  "pcClue.brand.broadcom": "Broadcom",
  "pcClue.brand.qualcomm": "Qualcomm",
  "pcClue.brand.mediatek": "MediaTek",
  "pcClue.hongKong": "Hong Kong",
  "pcClue.domestic": "Domestic",
  "pcClue.bondedArea": "Bonded area",
  "pcClue.other": "Other",
  "pcClue.originalCarton": "Original carton",
  "pcClue.genuine": "Genuine",
  "pcClue.originalPackage": "Original package",
  "pcClue.originalLabel": "Original label",
});

// 货源发布
export const sourcePublish = Object.freeze({
  "sourcePublish.ownerInfo": "Seller details",
  "sourcePublish.iAmOwner": "I am the seller",
  "sourcePublish.contact": "Contact",
  "sourcePublish.enterContact": "Enter a contact name",
  "sourcePublish.required": "Required",
  "sourcePublish.ms": "Ms.",
  "sourcePublish.mr": "Mr.",
  "sourcePublish.contactMethod": "Contact details",
  "sourcePublish.enterMobile": "Enter a mobile number",
  "sourcePublish.wechat": "WeChat",
  "sourcePublish.enterWechat": "Enter a WeChat ID",
  "sourcePublish.hometown": "Hometown",
  "sourcePublish.enterHometown": "Enter hometown",
  "sourcePublish.personality": "Personality",
  "sourcePublish.hobbies": "Interests",
  "sourcePublish.remarks": "Notes",
  "sourcePublish.ownerRemarks": "Enter seller notes",
  "sourcePublish.productInfo": "Product details",
  "sourcePublish.productLink": "Product ID/link",
  "sourcePublish.enterProductLink": "Enter a supply-demand listing ID or link",
  "sourcePublish.images": "Images",
  "sourcePublish.imageHint": "Drag to reorder; double-click to view",
  "sourcePublish.uploadProductImages": "Upload product images",
  "sourcePublish.productName": "Product name",
  "sourcePublish.enterProductName": "Enter a product name",
  "sourcePublish.brand": "Brand",
  "sourcePublish.enterBrand": "Enter a brand name",
  "sourcePublish.selectBrand": "Select brand",
  "sourcePublish.partNumber": "Part number",
  "sourcePublish.enterPartNumber": "Enter a part number",
  "sourcePublish.manufactureDate": "Manufacture date (DC)",
  "sourcePublish.selectManufactureDate": "Select a manufacture date",
  "sourcePublish.unitPrice": "Unit price",
  "sourcePublish.enterPrice": "Enter a unit price",
  "sourcePublish.quantity": "Quantity",
  "sourcePublish.enterQuantity": "Enter quantity",
  "sourcePublish.unit": "Unit",
  "sourcePublish.enterUnit": "Enter a unit",
  "sourcePublish.stockLocation": "Stock location",
  "sourcePublish.enterStockLocation": "Enter stock location",
  "sourcePublish.batch": "Batch (DC)",
  "sourcePublish.enterBatch": "Enter a batch",
  "sourcePublish.condition": "Goods condition",
  "sourcePublish.category": "Product category",
  "sourcePublish.selectCategory": "Select a product category",
  "sourcePublish.noAttributes": "No category attributes; select a subcategory",
  "sourcePublish.moreInfo": "Additional details",
  "sourcePublish.datasheet": "Datasheet",
  "sourcePublish.uploadDatasheet": "Upload datasheet",
  "sourcePublish.originProof": "Proof of origin",
  "sourcePublish.uploadProof": "Upload proof",
  "sourcePublish.manufacturer": "Manufacturer",
  "sourcePublish.enterManufacturer": "Enter manufacturer",
  "sourcePublish.weight": "Weight",
  "sourcePublish.enterWeight": "Enter weight",
  "sourcePublish.gram": "g",
  "sourcePublish.dimensions": "Dimensions",
  "sourcePublish.length": "Length",
  "sourcePublish.width": "Width",
  "sourcePublish.height": "Height",
  "sourcePublish.enterLength": "Enter length",
  "sourcePublish.enterWidth": "Enter width",
  "sourcePublish.enterHeight": "Enter height",
  "sourcePublish.millimeter": "mm",
  "sourcePublish.substitutes": "Alternatives",
  "sourcePublish.applications": "Applications",
  "sourcePublish.tagHint": "Separate with spaces or commas, then press Enter",
  "sourcePublish.minimumOrder": "Minimum order",
  "sourcePublish.enterMinimumOrder": "Enter minimum order",
  "sourcePublish.validity": "Validity",
  "sourcePublish.selectValidity": "Select validity",
  "sourcePublish.deliveryDays": "Delivery time",
  "sourcePublish.enterDeliveryDays": "Enter estimated delivery days",
  "sourcePublish.workingDays": "business days",
  "sourcePublish.ownerCompany": "Seller company",
  "sourcePublish.enterOwnerCompany": "Enter seller company name",
  "sourcePublish.productRemarks": "Enter product notes",
  "sourcePublish.informationProvider": "Information provider",
  "sourcePublish.anonymous": "Anonymous",
  "sourcePublish.assignedNegotiator": "Assigned negotiator",
  "sourcePublish.enterAssignedMobile": "Enter negotiator mobile number",
  "sourcePublish.saveDraft": "Save draft",
  "sourcePublish.notAvailable": "Not available yet",
  "sourcePublish.buyerInfo": "Buyer details",
  "sourcePublish.iAmBuyer": "I am the buyer",
  "sourcePublish.deliveryAddress": "Delivery address",
  "sourcePublish.enterDeliveryAddress": "Enter delivery address",
  "sourcePublish.buyerRemarks": "Enter buyer notes",
  "sourcePublish.demandInfo": "Purchase requirements",
  "sourcePublish.targetPrice": "Target price",
  "sourcePublish.enterTargetPrice": "Enter a target price",
  "sourcePublish.enterPurchaseQuantity": "Enter purchase quantity",
  "sourcePublish.recommendedNegotiator": "Recommended negotiator",
  "sourcePublish.enterRecommendedMobile": "Enter negotiator mobile number",
  "sourcePublish.searchCategory": "Search categories",
  "sourcePublish.select": "Select ",
  "sourcePublish.enter": "Enter ",
  "sourcePublish.confirm": "Confirm",
  "sourcePublish.chipSpecs": "Chip specifications",
  "sourcePublish.package": "Package",
  "sourcePublish.batchShort": "Batch",
  "sourcePublish.submit": "Submit",
  "sourcePublish.selectDate": "Select date",
  "sourcePublish.bulkUpload": "Bulk upload supply-demand listings",
  "sourcePublish.cancel": "Cancel",
  "sourcePublish.confirmPost": "Confirm post",
  "sourcePublish.postSupply": "Post supply",
  "sourcePublish.postSupplyLead": "Post a supply listing",
  "sourcePublish.postSupplyHint": "Enter supply details and post a listing",
  "sourcePublish.postDemand": "Post demand",
  "sourcePublish.postDemandLead": "Post a demand listing",
  "sourcePublish.postDemandHint": "Enter demand details and post a listing",
  "sourcePublish.submitPurchaseIntent": "Submit purchase intent",
  "sourcePublish.datasheetAttachment": "Datasheet attachment",
  "sourcePublish.cny": "CNY",
  "sourcePublish.usd": "USD",
  "sourcePublish.loginFirst": "Please sign in first",
  "sourcePublish.requiredField": "Required",
  "sourcePublish.validNumber": "Enter a valid number",
  "sourcePublish.postSuccess": "Posted successfully",
  "sourcePublish.failed": "Failed",
  "sourcePublish.completeForm": "Complete all required information",
  "sourcePublish.draftSaved": "Draft saved",
  "sourcePublish.uploading": "Uploading...",
  "sourcePublish.uploadSuccess": "Upload complete",
  "sourcePublish.uploadFailed": "Upload failed",
  "sourcePublish.chooseUpload": "Select a file to upload",
  "sourcePublish.waitUpload": "Wait for the upload to finish",
  "sourcePublish.importSuccess": "Import complete",
  "sourcePublish.importFailed": "Import failed",
  "sourcePublish.approximately": "Approx. ",
  "sourcePublish.maxTags": "You can add at most {count} tags",
  "sourcePublish.purchaseIntentSuccess":
    "Purchase intent submitted. Please wait for a negotiator.",
  "sourcePublish.enterAlternativeBrand": "Enter alternative brand",
  "sourcePublish.model": "Part number",
  "sourcePublish.enterAlternativeModel": "Enter alternative part number",
  "sourcePublish.originProofFile": "Proof of origin {count}",
});

// 供需详情
export const detail = Object.freeze({
  "supplyDetail.supplyDetails": "Supply details",
  "supplyDetail.demandDetails": "Demand details",
  "supplyDetail.stockSupply": "In-stock supply",
  "supplyDetail.wanted": "Purchase request",
  "supplyDetail.inventoryQuantity": "Available quantity",
  "supplyDetail.demandQuantity": "Required quantity",
  "supplyDetail.minimumOrder": "Minimum order quantity",
  "supplyDetail.warehouseSource": "Warehouse / source region",
  "supplyDetail.deliveryPeriod": "Lead time",
  "supplyDetail.validity": "Validity",
  "supplyDetail.publisher": "Publishing company",
  "supplyDetail.inquire": "Request a quote",
  "supplyDetail.quote": "Submit a quote",
  "supplyDetail.companyInfo": "Company information",
  "supplyDetail.contactName": "Contact",
  "supplyDetail.contactPhone": "Phone",
  "supplyDetail.contactNotice":
    "Contact details are subject to platform-verified records and the data returned by the service",
  "supplyDetail.details": "Details",
  "supplyDetail.partNumber": "Part number",
  "supplyDetail.specifications": "Specifications",
  "supplyDetail.condition": "Condition",
  "supplyDetail.application": "Applications",
  "supplyDetail.replacements": "Alternative part numbers",
  "supplyDetail.productionDate": "Production date",
  "supplyDetail.tradeNotes": "Trading notes",
  "supplyDetail.emptyNotes": "No additional notes",
  "supplyDetail.publication": "Publication information",
  "supplyDetail.publishedAt": "Published at",
  "supplyDetail.status": "Status",
  "supplyDetail.infoType": "Listing type",
  "supplyDetail.notFound": "Listing not found. It may have been removed",
  "supplyDetail.backHall": "Back to listings",
  "supplyDetail.backList": "Back to list",
  "supplyDetail.longTerm": "No expiry",
  "supplyDetail.validRange": "{from} to {to}",
  "supplyDetail.loadFailed": "Unable to load listing details. Please try again",
  "supplyDetail.inquiryPending": "Quote requests are not available yet",
  "supplyDetail.quotePending": "Quote submission is not available yet",
  "supplyDetail.status.pending": "Pending review",
  "supplyDetail.status.approved": "Reviewed",
  "supplyDetail.status.published": "Published",
  "supplyDetail.status.offline": "Removed",
});

// 供需大厅
export const hall = Object.freeze({
  "supplyHall.title": "Supply & demand",
  "supplyHall.intro":
    "Browse supply and demand listings, filter quickly, save items, and follow up on details.",
  "supplyHall.services": "Listing services",
  "supplyHall.serviceHint": "Post a listing or complete your company profile",
  "supplyHall.postSupply": "Post supply",
  "supplyHall.postDemand": "Post demand",
  "supplyHall.join": "Company onboarding",
  "supplyHall.productType": "Product type:",
  "supplyHall.originalDescription": "Original (Simplified Chinese)",
  "supplyHall.productBrand": "Brand:",
  "supplyHall.any": "Any",
  "supplyHall.expand": "Expand",
  "supplyHall.collapse": "Collapse",
  "supplyHall.search": "Search",
  "supplyHall.all": "All",
  "supplyHall.supply": "Supply",
  "supplyHall.demand": "Demand",
  "supplyHall.wanted": "Wanted",
  "supplyHall.brandPartPlaceholder": "Brand or part number",
  "supplyHall.quantity": "Quantity",
  "supplyHall.cards": "Cards",
  "supplyHall.table": "Table",
  "supplyHall.uncategorized": "Uncategorized",
  "supplyHall.stock": "Stock",
  "supplyHall.demandQuantity": "Required quantity",
  "supplyHall.minimumOrder": "Minimum order",
  "supplyHall.delivery": "Delivery",
  "supplyHall.viewDetails": "View details",
  "supplyHall.details": "Details",
  "supplyHall.type": "Type",
  "supplyHall.partNumber": "Part number",
  "supplyHall.brand": "Brand",
  "supplyHall.category": "Category",
  "supplyHall.price": "Price",
  "supplyHall.location": "Location",
  "supplyHall.action": "Action",
  "supplyHall.mainland": "Mainland China",
  "supplyHall.hongKong": "Hong Kong",
  "supplyHall.empty": "No matching listings",
  "supplyHall.total": "{count} listings",
  "supplyHall.searchBrand": "Search brands",
  "supplyHall.brandPlaceholder": "Enter a brand name",
  "supplyHall.searching": "Searching...",
  "supplyHall.noBrand": "No matching brands",
  "supplyHall.cancel": "Cancel",
  "supplyHall.confirm": "Confirm",
  "supplyHall.loadFailed": "Couldn't load listings. Please try again.",
  "supplyHall.days": "{count} days",
  "supplyHall.chooseBrand": "Select a brand",
  "supplyHall.realnameNotice":
    "Identity verification is required before posting. Go to verification?",
  "supplyHall.notice": "Notice",
  "supplyHall.goRealname": "Verify identity",
  "supplyHall.joinSuccess": "Company onboarding completed",
  "supplyHall.joinFailed": "Company onboarding failed",
  "supplyHall.unfavorited": "Removed from favorites",
  "supplyHall.published": "Published",
  "supplyHall.favorited": "Added to favorites",
  "supplyHall.tenThousands": "{count} × 10,000",
});

// 供需发布
export const publish = Object.freeze({
  "pcPublish.supplyTitle": "Publish supply",
  "pcPublish.demandTitle": "Publish demand",
  "pcPublish.category": "Category",
  "pcPublish.brand": "Brand",
  "pcPublish.partNumber": "Part number",
  "pcPublish.unitPrice": "Unit price",
  "pcPublish.quantity": "Quantity",
  "pcPublish.batch": "Batch",
  "pcPublish.parameters": "Specifications",
  "pcPublish.tradeNotes": "Trade notes",
  "pcPublish.selectFromList": "Select from the list",
  "pcPublish.searchAndSelect": "Type to search and select",
  "pcPublish.enterPartNumber": "Enter a part number",
  "pcPublish.enterValue": "Enter a value",
  "pcPublish.enterText": "Enter text",
  "pcPublish.yuan": "CNY",
  "pcPublish.confirm": "Publish",
  "pcPublish.searchCategory": "Search categories",
  "pcPublish.searchBrand": "Search brands",
  "pcPublish.categoryResult": "{count} results matching “{keyword}”",
  "pcPublish.brandCount": "{count} brands",
  "pcPublish.noSubcategory":
    "No subcategories; you can select this category directly",
  "pcPublish.chooseCategory": "Select this category",
  "pcPublish.chooseBrand": "Choose a brand",
  "pcPublish.categoryRequired": "Select a category.",
  "pcPublish.brandRequired": "Select a brand.",
  "pcPublish.partNumberRequired": "Enter a part number.",
  "pcPublish.priceRequired": "Enter a unit price.",
  "pcPublish.quantityRequired": "Enter a quantity.",
  "pcPublish.success": "Published successfully",
  "pcPublish.failed": "Could not publish. Please retry",
  "pcPublish.networkFailed":
    "Could not publish. Check your connection and try again",
  "pcPublish.images": "Images",
  "pcPublish.uploadImage": "Upload images",
  "pcPublish.categoryHint": "Select a site category",
  "pcPublish.brandHint": "Search and select a brand",
  "pcPublish.partNumberHint": "Enter or search for a part number",
  "pcPublish.specification": "Specification",
  "pcPublish.specificationHint": "Enter specifications",
  "pcPublish.title": "Listing title",
  "pcPublish.supplyTitleHint":
    "Include origin, supply, part number, quantity and alternatives as needed",
  "pcPublish.demandTitleHint":
    "Include origin, demand, part number, quantity and alternatives as needed",
  "pcPublish.currency": "Currency",
  "pcPublish.chooseCurrency": "Select a currency",
  "pcPublish.currencyCNY": "CNY - Chinese yuan",
  "pcPublish.currencyUSD": "USD - US dollar",
  "pcPublish.currencyEUR": "EUR - Euro",
  "pcPublish.currencyGBP": "GBP - British pound",
  "pcPublish.currencyJPY": "JPY - Japanese yen",
  "pcPublish.currencyHKD": "HKD - Hong Kong dollar",
  "pcPublish.unit": "Unit",
  "pcPublish.minimumOrder": "Minimum order",
  "pcPublish.manufactureDate": "Manufacture date",
  "pcPublish.chooseDate": "Select a manufacture date",
  "pcPublish.origin": "Goods origin",
  "pcPublish.enterOrigin": "Enter goods origin",
  "pcPublish.validity": "Validity",
  "pcPublish.chooseValidity": "Select an expiry date",
  "pcPublish.longTerm": "No expiry",
  "pcPublish.deliveryDays": "Delivery days",
  "pcPublish.applications": "Applications",
  "pcPublish.tagsHint": "Enter tags separated by spaces or commas",
  "pcPublish.alternatives": "Alternatives",
  "pcPublish.chooseBrandHint": "Select a brand",
  "pcPublish.size": "Dimensions",
  "pcPublish.length": "Length",
  "pcPublish.width": "Width",
  "pcPublish.height": "Height",
  "pcPublish.millimeter": "mm",
  "pcPublish.weight": "Weight",
  "pcPublish.gram": "g",
  "pcPublish.ownerCompany": "Owner company",
  "pcPublish.defaultCompany": "Defaults to the member company",
  "pcPublish.datasheet": "Upload datasheet",
  "pcPublish.notes": "Notes",
  "pcPublish.notesHint": "Enter notes",
  "pcPublish.preview": "Preview listing",
  "pcPublish.selectAlternativeBrand": "Select an alternative brand",
  "pcPublish.previewUnavailable": "Preview is not available yet",
  "pcPublish.imageRequired": "Upload an image.",
});

// 手机端业务流程：三语只改变固定界面文案。
export const mobileWorkflow = Object.freeze({
  "supplyForm.awaitingContact": "Awaiting contact",
  "supplyForm.negotiatorAccepted": "Accepted by negotiator",
  "supplyForm.businessAccepted": "Accepted by business representative",
  "supplyForm.contractCreated": "Contract created",
  "supplyForm.confirmAmount": "Confirm amount",
  "supplyForm.buyerPaid": "Buyer paid",
  "supplyForm.sellerPaid": "Seller paid",
  "supplyForm.reviewTitle": "Review information",
  "supplyForm.editSupplyLead": "Edit supply lead",
  "supplyForm.enterPrice": "Enter a price",
  "supplyForm.completeSupply": "Complete supply information",
  "supplyForm.uploadImage": "Upload a product image",
  "supplyForm.completeBeforeSave":
    "Complete all required information before saving.",
  "supplyForm.bulk": "Bulk trading",
  "supplyForm.searchableTitle":
    "A descriptive title helps others find your product",
  "supplyForm.enterField": "Enter a value",
  "supplyForm.enterCondition": "Enter the product condition",
  "supplyForm.enterPackageType": "Enter the package type",
  "supplyForm.enterChipType": "Enter the chip type",
  "supplyForm.enterUnitPrice": "Enter the unit price",
  "supplyForm.enterProductTitle": "Enter a product title",
  "supplyForm.notRegistered": "(Not registered)",
  "supplyForm.saveNext": "Save and continue",
  "supplyForm.savePublish": "Save and publish supply",
  "supplyForm.currentStatusPrefix": "Current status:",
  "supplyForm.negotiatorPrefix": "Negotiator:",
  "supplyForm.pdfRequired": "Upload a PDF file",
  "supplyForm.pricePositive": "The price must be greater than zero",
  "supplyForm.quantityPositive": "The quantity must be greater than zero",
  "supplyForm.reviewConfirm": "Approve this record?",
  "supplyForm.deleteConfirm": "Delete this lead?",
  "supplyForm.dimensionsMm": "{dimensions} mm",
  "supplyForm.deliveryWorkdays": "{days} working days",
  "supplyForm.approximateConversion": "(approx. {amount} {unit})",
  "supplyForm.editInformation": "Edit information",
  "supplyForm.enterSupplier": "Enter a supplier",
  "supplyForm.enterProductType": "Enter a product type",
  "supplyForm.enterArchitecture": "Enter the architecture",
  "supplyForm.enterSpeed": "Enter the speed",
  "supplyForm.enterBall": "Enter the ball position",
});

// 页面受控选项与属性显示；原始业务值保持不变。
export const publishDisplayFollowup = Object.freeze({
  "publishDisplay.bulk": "Bulk goods",
  "publishDisplay.postSupply": "Post supply",
  "publishDisplay.postDemand": "Post demand",
  "publishDisplay.hasOriginProof": "Certificate available",
  "publishDisplay.noOriginProof": "No certificate",
  "publishDisplay.unknownOriginProof": "Unknown",
  "publishDisplay.tagExample": "Example: category1, category2, category3",
  "publishDisplay.computers": "Computers",
  "publishDisplay.phones": "Phones",
  "publishDisplay.automotive": "Automotive",
  "publishDisplay.iot": "IoT",
  "publishDisplay.networks": "Networking",
});

export const messages = Object.freeze({
  ...publishDisplayFollowup,
  ...mobileWorkflow,
  ...mobileClue,
  ...batchPublish,
  ...desktopClue,
  ...sourcePublish,
  ...detail,
  ...hall,
  ...publish,
});
